import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
`;

export const Description = styled.span`
  text-align: center;
  margin-top: 50px;
  font-size: 16px;
  color: #7f7f7f;

  @media (min-width: 1000px) {
    font-size: 18px;
  }
`;

export const Link = styled.a`
  cursor: pointer;
  margin-left: 5px;
  color: black;
  font-size: 18px;
  text-decoration: none;
`;
